import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import { MENU_SCREEN_CONFIG } from './base/menu-screen-config';

export const menuScreenRoutes: Routes = [
  {
    path: MENU_SCREEN_CONFIG.routePath!,
    data: { title: 'Menu Screen' },
    canActivate: [
      roleGuard('ADMIN_MASTER'),
      permissionGuard('HOME_SCREEN$READ'),
    ],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/menu-screen-list-page/menu-screen-list-page.component'
          ).then((m) => m.MenuScreenListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/menu-screen-detail-page/menu-screen-detail-page.component'
              ).then((m) => m.MenuScreenDetailPageComponent),
            data: { title: 'Menu Screen Detail' },
          },
        ],
      },
    ],
  },
];
